import api from './api';

const countriesService = {
  getAll: async () => {
    const response = await api.get('/country/get-country');
    return response.data.data || response.data;
  },

  create: async (data) => {
    const response = await api.post('/country/add-country', data);
    return response.data.data || response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/country/update-country/${id}`, data);
    return response.data.data || response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/country/delete-country/${id}`);
    return response.data;
  },
};

export default countriesService;
